module.exports = __webpack_public_path__ + "static/media/bruno-abatti.dcc3b6c8.jpg";